import React, { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import toast from "react-hot-toast";

const WeekNotes = ({ weekIndex, noteText, updateRoadmap, roadmapData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [note, setNote] = useState(noteText || "");
  const [originalNote, setOriginalNote] = useState(noteText || "");
  const isMobile = window.innerWidth < 768;
  const hasContent = (noteText || "").trim() !== "";

  useEffect(() => {
    // Update note content if it changes from parent
    setNote(noteText || "");
    setOriginalNote(noteText || "");
  }, [noteText]);

  const saveNote = () => {
    // Only save and show toast if content actually changed
    if (note !== originalNote && updateRoadmap && roadmapData) {
      const updatedRoadmap = [...roadmapData];
      const noteIndex = weekIndex * 2 + 1;
      if (noteIndex < updatedRoadmap.length) {
        updatedRoadmap[noteIndex] = note;
        updateRoadmap(updatedRoadmap);
        toast.success("Nota aggiornata con successo");
        setOriginalNote(note); // Update the original note to match current state
      }
    }
  };

  console.log(isMobile,)


  return (
    <div className="h-full flex">
      <div className="md:mt-12 mt-0">
        {/* Linea - Button/Note - Linea */}{isMobile ? (
          <div className={`flex flex-col md:flex-row justify-center items-center ${(isMobile && isOpen || hasContent) && "hidden"}`}>
            {<div
              className={`flex md:h-[2px] h-14 w-[2px] bg-gray-200 ${isOpen || hasContent ? "md:w-32" : "md:w-14"
                }`}
            />}

            {/* DESKTOP: sempre mostra il button */}
            {!isMobile && (
              <div
                className="flex aspect-square justify-center items-center bg-white border-2 border-gray-200 active:border-black p-[10px] rounded-[8px] cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
              >
                <MessageCircle size={16} />
              </div>
            )}

            {/* MOBILE: se ha già contenuto NON mostra il button, altrimenti sì */}
            {isMobile && !hasContent && !isOpen && (
              <div
                className="flex aspect-square justify-center items-center bg-white border-2 border-gray-200 active:border-black p-[10px] rounded-[8px] cursor-pointer"
                onClick={() => setIsOpen(true)}
              >
                <MessageCircle size={16} />
              </div>
            )}

            <div
              className={`flex md:h-[2px] h-14 w-[2px] bg-gray-200 ${isOpen || hasContent ? "md:w-32" : "md:w-14"
                }`}
            />
          </div>
        ) : (
          <div className={`flex flex-col md:flex-row justify-center items-center ${(isMobile && isOpen) && "hidden"}`}>
            {<div
              className={`flex md:h-[2px] h-14 w-[2px] bg-gray-200 ${isOpen || hasContent ? "md:w-32" : "md:w-14"
                }`}
            />}

            {/* DESKTOP: sempre mostra il button */}
            {!isMobile && (
              <div
                className="flex aspect-square justify-center items-center bg-white border-2 border-gray-200 active:border-black p-[10px] rounded-[8px] cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
              >
                <MessageCircle size={16} />
              </div>
            )}

            {/* MOBILE: se ha già contenuto NON mostra il button, altrimenti sì */}
            {isMobile && !hasContent && !isOpen && (
              <div
                className="flex aspect-square justify-center items-center bg-white border-2 border-gray-200 active:border-black p-[10px] rounded-[8px] cursor-pointer"
                onClick={() => setIsOpen(true)}
              >
                <MessageCircle size={16} />
              </div>
            )}

            <div
              className={`flex md:h-[2px] h-14 w-[2px] bg-gray-200 ${isOpen || hasContent ? "md:w-32" : "md:w-14"
                }`}
            />
          </div>
        )}

        {/* DESKTOP: sotto il button SOLO SE c'è già contenuto o è stato aperto */}
        {!isMobile && (hasContent || isOpen) && (
          <div className="flex flex-col w-full items-center">
            {/* Linea verticale */}
            {(hasContent || isOpen) && <div className="h-16 w-[2px] bg-gray-200" />}
            <div className="p-2 border-2 border-gray-200 rounded-[8px] bg-white max-w-56">
              <textarea
                className="w-full text-sm resize-none outline-none"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onBlur={saveNote}
                placeholder="Aggiungi note o commenti per questa settimana..."
              />
            </div>
          </div>
        )}

        {/* MOBILE: se ha già contenuto oppure ha cliccato per aprire */}
        {isMobile && (hasContent || isOpen) && (
          <div className="flex flex-col w-full items-center">
            <div className="h-16 w-[2px] bg-gray-200" />
            <div className="p-2 border-2 border-gray-200 rounded-[8px] bg-white max-w-56">
              <textarea
                className="w-full text-sm resize-none outline-none"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onBlur={saveNote}
                placeholder="Aggiungi note o commenti per questa settimana..."
              />
            </div>
            <div className="h-16 w-[2px] bg-gray-200" />
          </div>
        )}
      </div>
    </div>
  );
};

export default WeekNotes;